<template>
	<div id="page" v-cloak>
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(item, index) in images" :key="index">
        <img v-lazy="'http://dig-mineral.yeedian365.com/h5_image/'+item.flash_img" @click="openUrl(item.flash_url)"/>
      </van-swipe-item>
    </van-swipe>
		<div class="task">
      <h1 class="task_title">
      	版本更新
      </h1>
      <ul class="task_list">
      	<li class="clear">
      		<img src="../img/logo.png" alt="">
      		<div>
      			<p>来啊最新V1.2.0版本</p>
            <p>更新版本体验最新功能</p>
      		</div>
      		<input type="button" value="点击更新" @click="openUrl('http://laia-common.yeedian365.com/client_package/channel/laia_1.2.0_05131048_100_0.apk')">
      	</li>
      </ul>
      <h1 class="task_title">
      	淘宝大礼包
      </h1>
      <ul class="task_list">
      	<li class="clear">
      		<img src="../img/taobao.png" alt="">
      		<div>
      			<p>商城购物领奖励</p>
      			<p>购物奖钻石，需要确认收货后才可提交上传审核</p>
      		</div>
      		<input type="button" value="去上传" @click="openUrl('http://laia-common.yeedian365.com/laia_h5/index.html#/Upload')">
      	</li>
      </ul>
			<h1 class="task_title">
				日常任务
			</h1>
			<ul class="task_list">
				<li class="clear">
					<img src="../img/red_packet_icon.png" alt="">
					<div>
						<p>领现金红包</p>
						<p>每邀请{{initData.invite_count}}个好友可领取一个随机现金红包，目前{{initData.ungain_invite_count}}/{{initData.invite_count}}个</p>
					</div>
					<input type="button" value="领取" :class="{ disabled : initData.invite_gain_status==0}" :disabled="initData.invite_gain_status==1?false:true" @click="getTaskBounty(1)">
				</li>
				<li class="clear">
					<img src="../img/escalate_icon.png" alt="">
					<div>
						<p>升级领红包</p>
						<p>用户每提升一级可领取一个随机现金红包</p>
					</div>
					<input type="button" value="领取" :class="{ disabled : initData.levelup_gain_status==0}" :disabled="initData.levelup_gain_status==1?false:true" @click="getTaskBounty(2)">
				</li>
				<li class="clear">
					<img src="../img/invite_icon.png" alt="">
					<div>
						<p>邀请好友</p>
						<p>邀请一个好友奖励钻石速度+{{initData.invite_add_level}}，每天上限{{initData.invite_add_level_sum}}/{{initData.invite_add_level_limit}}</p>
					</div>
					<input type="button" value="去邀请好友" @click="inviteFriends">
				</li>
				<li class="clear">
					<img src="../img/send_icon.png" alt="">
					<div>
						<p>发红包</p>
						<p>每天发布一个红包奖励钻石速度+{{initData.send_redpacket_add_level}}，每天上限{{initData.send_redpacket_add_level_sum}}/{{initData.send_redpacket_add_level_limit}}</p>
					</div>
					<input type="button" value="奖励详情" @click="dialogTask(1)">
				</li>
			</ul>
		</div>
    <transition name="fade">
    	<div class="dialog_masking" v-if="visible" >
    		<div class="dialog">
    			<p class="dialog_title">做任务领奖励</p>
    			<div class="dialog_content" v-bind:class="{ dialog_content_center : textAlignCenter}">
            <p class="dialog_task_subhead">完成每日任务，获得更多的奖励</p>
            <ul class="dialog_task_info clear">
              <li>
                <p>{{taskInfo.today_count}}</p>
                <p>今日次数</p>
              </li>
              <li>
                <p>{{taskInfo.today_reward}}</p>
                <p>今日奖励</p>
              </li>
              <li>
                <p>{{taskInfo.total_reward}}</p>
                <p>累计奖励</p>
              </li>
            </ul>
          </div>
    			<div class="dialog_button clear" v-if="dialogButton">
    				<input type="button" value="取消">
    				<input type="button" value="确认">
    			</div>
    		</div>
    	</div>
    </transition>
	</div>
</template>
<script>
	export default {
		name: 'DailyTask',
		data() {
			return {
				userId: '',
				H5Key: '',
				md5: '',
        visible: false,
        dialogButton: false,
        textAlignCenter: false,
        dialogContent: "",
				initData: {},
        taskInfo: {},
				images: [],
			}
		},
		mounted() {
			if(window.LaiaJs){
				window.LaiaJs.setTitle('每日任务');
				this.userId = window.LaiaJs.getUserId();
				this.H5Key = window.LaiaJs.getH5Key();
				this.md5 = this.$md5(this.H5Key);
			}else{
				this.userId = '503a84e4f4374ec5916db6086bbe7b71';
				this.H5Key = 'UpSzXt4t5tSwTD2uYqVC1vPxVA1DWAWq';
				this.md5 = this.$md5(this.H5Key);
			}
			this.initialization();
		},
		methods: {
			initialization() {
        //初始化数据
				this.$axios.post("task/getTaskInfo.do", {
					"user_id": this.userId,
					"sign": this.md5,
				}).then((res) => {
					// console.log(res);
					if(res.data.Error != ""){
						if(window.LaiaJs){
							window.LaiaJs.showMsg(res.data.Error);
							return;
						}else{
							alert(res.data.Error);
							return;
						}
					}
					this.initData = res.data;
				}).catch((e) => {
					//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
					console.log(e);
				})
        //轮播图
        this.$axios.get("https://h5.wake888.com/index/Flash/getLaiaFlash2")
        .then((res) => {
        	// console.log(res);
        	this.images = res.data;
        }).catch((e) => {
        	//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        	console.log(e);
        })
			},
      // 任务详情弹窗
      async dialogTask(type) {
        var _this = this;
        let res = await _this.$axios.post("task/getTaskDialogData.do", {
          "user_id": _this.userId,
          "sign": _this.md5,
          "type": type
        })
        try{
          if(res.data.Error != ""){
            if(window.LaiaJs){
              window.LaiaJs.showMsg(res.data.Error);
              return;
            }else{
              alert(res.data.Error);
              return;
            }
          }
          _this.taskInfo = res.data;
          _this.visible = !_this.visible;
          setTimeout(()=>{
            _this.visible = !_this.visible;
          },2000)
        }catch(error){
          console.log(error)
        }
      },
      // 领取任务
      getTaskBounty(type) {
        this.initData.invite_gain_status == 0;
        this.initData.levelup_gain_status == 0;
      	this.$axios.post("task/gainDailyTaskMoneyReward.do", {
      		"user_id": this.userId,
      		"sign": this.md5,
      		"type": type,
      	}).then((res) => {
      		// console.log(res);
      		if(res.data.Error != ""){
      			if(window.LaiaJs){
      				window.LaiaJs.showMsg(res.data.Error);
      				return;
      			}else{
      				alert(res.data.Error);
      				return;
      			}
      		}
      		if(window.LaiaJs){
      			window.LaiaJs.addMoney('+'+res.data.reward);
            this.initialization();
      		}
      	}).catch((e) => {
      		//联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.initialization();
      		console.log(e);
      	})
      },
      // 邀请好友
      inviteFriends() {
        if(window.LaiaJs){
          window.LaiaJs.showShareCard();
        }
      },
      // 轮播图广告跳转
      openUrl(url) {
        if(window.LaiaJs){
          window.LaiaJs.openUrl(url);
        }else{
          window.location.href = url;
        }
      },
		}
	}

</script>

<style scoped>
	[v-cloak] {
		display: none;
	}
	#page {
		width: 100%;
		height: 100vh;
		background-color: #eaf1f7;
	}
	.van-swipe,.van-swipe img{
		height: 2.76rem;
	}
	.task{
		margin-top: 0.25rem;
		background-color: #fff;
	}
	.task_title{
		height: 1.5rem;
		line-height: 1.5rem;
		font-size: 0.4rem;
		color: #3b4559;
		border-bottom: 1px solid #bdc0c2;
		padding-left: 0.52rem;
	}
	.task_list{

	}
	.task_list li{
		height: 1.72rem;
		border-bottom: 1px solid #bfc2c4;
		padding-left: 0.52rem;
		padding-right: 0.48rem;
		overflow: hidden;
	}
	.task_list li img{
		float: left;
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 0.8rem;
		margin-top: 0.46rem;
	}
	.task_list li div{
		float: left;
		margin-left: 0.28rem;
		padding-top: 0.3rem;
	}
	.task_list li div p:first-child{
		height: 0.52rem;
		font-size: 0.4rem;
		color: #3f4858;
	}
	.task_list li div p:last-child{
		width: 6.4rem;
		font-size: 0.32rem;
		color: #9c9ea3;
	}
	.task_list li input{
		float: right;
		width: 2.25rem;
		height: 0.67rem;
		font-size: 0.36rem;
		color: #fff;
		border: 1px solid #3672f9;
    background-color: #3672f9;
		border-radius: 0.1rem;
		margin-top: 0.5rem;
	}
  .task_list li .disabled{
  	opacity: 0.5;
    color: #3672f9;
    background-color: #fff;
  }
  .dialog_task_subhead{
    color: #3f4858;
    text-align: center;
  }
  .dialog_task_info{
    margin-top: 0.5rem;
    margin-bottom: -0.1rem;
    height: 2rem;
    border-radius: 0.1rem;
    background-color: rgba(54,114,249,0.9);
  }
  .dialog_task_info li{
    float: left;
    width: 33.33%;
    color: #fff;
    text-align: center;
  }
  .dialog_task_info li p:first-child{
    font-size: 0.54rem;
    padding-top: 0.3rem;
    font-weight: bold;
  }
  .dialog_task_info li p:last-child{
    font-size: 0.34rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/DailyTask.vue